export default __webpack_public_path__ + "static/media/icon_4_0.de65d28e.svg";